import config from './config/config';

const histoty = {
  action: config.pushName
};

export default histoty;
